const TEXT_NODE = typeof Node !== "undefined" && Node.TEXT_NODE ? Node.TEXT_NODE : 3;
const ELEMENT_NODE = typeof Node !== "undefined" && Node.ELEMENT_NODE ? Node.ELEMENT_NODE : 1;
function collectTextNodes(paragraph) {
  const textNodes = [];
  function traverse(node) {
    if (node.nodeType === TEXT_NODE) {
      if (node.textContent.trim()) {
        textNodes.push(node);
      }
    } else {
      node.childNodes.forEach(child => traverse(child));
    }
  }
  traverse(paragraph);
  return textNodes;
}
function wrapWithFormatAncestors(wordText, textNode, paragraph) {
  const doc = paragraph.ownerDocument;
  let inner = doc.createTextNode(wordText);
  let node = textNode.parentNode;
  while (node && node !== paragraph) {
    if (node.nodeType === ELEMENT_NODE && node.nodeName !== "BR") {
      const clone = node.cloneNode(false);
      clone.appendChild(inner);
      inner = clone;
    }
    node = node.parentNode;
  }
  return inner;
}
function isEffectivelyEmpty(node) {
  if (!node) {
    return true;
  }
  if (node.textContent && node.textContent.trim()) {
    return false;
  }
  if (typeof node.querySelector === "function" && node.querySelector("br, img")) {
    return false;
  }
  return true;
}
function pruneEmptyAncestors(textNode, paragraph) {
  let node = textNode;
  while (node && node !== paragraph) {
    const parent = node.parentNode;
    if (!parent) {
      break;
    }
    parent.removeChild(node);
    if (parent === paragraph) {
      break;
    }
    if (!isEffectivelyEmpty(parent)) {
      break;
    }
    node = parent;
  }
}
function getWords(element) {
  const text = element.textContent.trim();
  if (!text) {
    return [];
  }
  return text.split(/\s+/);
}
function peekEdgeWord(paragraph, fromEnd) {
  const words = getWords(paragraph);
  if (words.length === 0) {
    return null;
  }
  const wordText = fromEnd ? words[words.length - 1] : words[0];
  const remainingText = (fromEnd ? words.slice(0, -1) : words.slice(1)).join(" ");
  return {
    wordText,
    remainingText,
    wordCount: words.length
  };
}
function extractEdgeWord(paragraph, fromEnd) {
  const textNodes = collectTextNodes(paragraph);
  if (textNodes.length === 0) {
    return null;
  }
  const textNode = fromEnd ? textNodes[textNodes.length - 1] : textNodes[0];
  const raw = textNode.textContent;
  const words = raw.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return null;
  }
  const wordText = fromEnd ? words[words.length - 1] : words[0];
  const remainingWords = fromEnd ? words.slice(0, -1) : words.slice(1);
  const remaining = remainingWords.join(" ");
  const fragment = wrapWithFormatAncestors(wordText, textNode, paragraph);
  if (remaining) {
    if (fromEnd) {
      const leading = raw.match(/^\s*/)[0];
      textNode.textContent = leading + remaining;
    } else {
      const trailing = raw.match(/\s*$/)[0];
      textNode.textContent = remaining + trailing;
    }
  } else {
    pruneEmptyAncestors(textNode, paragraph);
  }
  return {
    fragment,
    wordText
  };
}
function appendWord(paragraph, fragment) {
  if (paragraph.textContent.trim()) {
    paragraph.appendChild(paragraph.ownerDocument.createTextNode(" "));
  }
  paragraph.appendChild(fragment);
}
function prependWord(paragraph, fragment) {
  const doc = paragraph.ownerDocument;
  if (paragraph.firstChild) {
    paragraph.insertBefore(doc.createTextNode(" "), paragraph.firstChild);
    paragraph.insertBefore(fragment, paragraph.firstChild);
  } else {
    paragraph.appendChild(fragment);
  }
}
function createParagraphFromFragment(sourceParagraph, fragment) {
  const paragraph = sourceParagraph.ownerDocument.createElement("p");
  paragraph.className = sourceParagraph.className;
  paragraph.appendChild(fragment);
  return paragraph;
}
function displayLength(element) {
  return element.textContent.trim().length;
}
function movedLineLength(destinationLength, wordText) {
  return destinationLength + wordText.length + (destinationLength > 0 ? 1 : 0);
}
export default {
  getWords,
  peekFirstWord: paragraph => peekEdgeWord(paragraph, false),
  peekLastWord: paragraph => peekEdgeWord(paragraph, true),
  extractFirstWord: paragraph => extractEdgeWord(paragraph, false),
  extractLastWord: paragraph => extractEdgeWord(paragraph, true),
  appendWord,
  prependWord,
  createParagraphFromFragment,
  displayLength,
  movedLineLength
};